import React from "react";
import SupportLayout from "../support/SupportLayout";
import AdminReports from "./components/AdminReports";

const AdminHome = () => {
    return (
        <SupportLayout userRole="ADMIN">
            <div className="pb-40">
                <div className="main_container_title_div mb-5 mt-10">
                    <h1 className="text-3xl sm:text-4xl font-bold text-gray-900 font-gilroyBold">
                        Admin Portal
                    </h1>
                    <p className="text-gray-600 text-xl sm:text-base">
                        Manage system reports and operations
                    </p>
                </div>

                <AdminReports />
            </div>
        </SupportLayout>
    );
};

export default AdminHome;
